// constants.ts

export const NAME = 'allPatients';